import styled from "@emotion/styled";

export const AuthorBioContainer = styled.div``;
